import { CdkColumnDef, CdkTable } from '@angular/cdk/table';
import {
  Component, OnInit, Input, Output, EventEmitter,
  AfterContentInit, ViewChild, ContentChildren, QueryList
} from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';

import { getPathValue } from 'app/utils/get';
import { TableColumnDef, TableRowDef } from 'models/table.model';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent<T extends Record<string, any>> implements OnInit, AfterContentInit {
  data$ = new BehaviorSubject<T[]>([]);

  dataSource$ = new BehaviorSubject<T[]>([]);

  @Output() rowSelected = new EventEmitter<T>();

  @Output() onSort = new EventEmitter<string[]>();

  @Input() set data(data: T[]) {
    this.data$.next(data);
  }

  @Input() sortKey!: string[];

  @Input() sortDirection!: string;

  @Input() displayedColumns!: string[];

  @Input() columnDefs!: TableColumnDef<T>[];

  @Input() rowDef!: TableRowDef<T>;

  @ViewChild(CdkTable, { static: true }) table!: CdkTable<T>;

  @ContentChildren(CdkColumnDef) cdkColumnDefs!: QueryList<CdkColumnDef>;

  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  ngAfterContentInit(): void {
    // the <ng-content> column definitions are available, we can add them to the table
    this.cdkColumnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef));
  }

  private init(): void {
    combineLatest([this.data$])
      .subscribe(([data]) => {
        if (!data) {
          return;
        }

        this.dataSource$.next(data);
      });
  }

  sortBy(keys?: string[]): void {
    if (keys !== undefined) {
      this.onSort.emit(keys);
    }
  }

  onRowClick(row: T): void {
    this.rowSelected.emit(row);
  }

  getCellValue(row: T, path: string): any {
    return getPathValue(row, path);
  }
}
